import axiosConfig from "../utils/axiosConfig";

const addBankStatement = (
  name,
  priceInput,
  priceOutput,
  month,
  base64,
  mime,
  callback
) => {
  axiosConfig("/bank-statement/add-bank-statement", {
    data: {
      name,
      priceInput,
      priceOutput,
      month,
      base64,
      mime,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const updateBankStatement = (
  id,
  name,
  priceInput,
  priceOutput,
  month,
  callback
) => {
  axiosConfig("/bank-statement/update-bank-statement", {
    data: {
      id,
      name,
      priceInput,
      priceOutput,
      month,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const getBankStatements = (callback) => {
  axiosConfig("/bank-statement/get-bank-statements")
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const downloadBankStatement = (id, callback) => {
  axiosConfig("/bank-statement/download-bank-statement", {
    data: {
      id,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const deleteBankStatement = (id, callback) => {
  axiosConfig("/bank-statement/delete-bank-statement", {
    data: {
      id,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const getStatisticsBankStatement = (callback) => {
  axiosConfig("/bank-statement/get-statistics-bank-statement")
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

export {
  addBankStatement,
  updateBankStatement,
  getBankStatements,
  downloadBankStatement,
  deleteBankStatement,
  getStatisticsBankStatement,
};
